import { SalesReportExportActions } from './elements/SalesReportExportActions'

export const SalesReportSideActions = () => {
  return <SalesReportExportActions />
}
